import { Component, Inject } from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { Mygroup } from "@models/group.model";

@Component({
    selector: 'app-modal-resumen-ingreso',
    templateUrl: './modal-resumen-ingreso.component.html',
    styleUrls: ['./modal-resumen-ingreso.component.scss'],
    standalone: false
})
export class modalResumenIngresoComponent
{
	inputValue: string = '';
	checked: boolean = false;
	selectedOption: string = '';
	public paguitas: Array<any> = [];
	public total: number = 0;
	public importe_por_miembro: number = 0;
	public resto: number = 0;
	public checkboxState: boolean = false;

	constructor(@Inject(MAT_DIALOG_DATA) public data: {cantidad: number, miembros: Array<number>, grupo: Mygroup},
		public dialogRef: MatDialogRef<modalResumenIngresoComponent>){

		this.total = data.cantidad;
		this.importe_por_miembro = Math.floor((data.cantidad / data.miembros.length) * 100) / 100;
		this.resto = data.cantidad - (this.importe_por_miembro * data.miembros.length);

		data.grupo.miembros.forEach(element => {
			if (data.miembros.indexOf(element.cliente_id) != -1) {
				let cant = this.importe_por_miembro;
				let message = "1/" + data.miembros.length + " del total";
				if (data.grupo.administrador_id == element.cliente_id && this.resto > 0) {
					cant += this.resto;
					message += " + resto";
				}

				let member = {
					cantidad: cant,
					nombre: element.nombre + " " + element.apellido_1,
					imagen: element.imagen,
					message: message
				}

				this.paguitas.push(member);
			}
			else if (data.grupo.administrador_id == element.cliente_id && this.resto > 0) {
				let cant = this.resto;
				let member = {
					cantidad: cant,
					nombre: element.nombre + " " + element.apellido_1,
					imagen: element.imagen,
					message: "Resto"
				}
				this.paguitas.unshift(member);
			}
		});
	}

	confirm(): void {
		this.dialogRef.close(true);
	}

	cancel(): void {
		this.dialogRef.close(null);
	}

	public onCheckboxChange(event: any) {
		this.checkboxState = event.target.checked;
		localStorage.setItem('askresumen', (event.target.checked ? 'false' : 'true'));
	}
}